import { render, staticRenderFns } from "./TidyUpSettings.vue?vue&type=template&id=6387a98c&scoped=true"
import script from "./TidyUpSettings.vue?vue&type=script&lang=js"
export * from "./TidyUpSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6387a98c",
  null
  
)

export default component.exports